const KEY = '32d.os.recent_pages';
const SKIP = new Set(['/login', '/register', '/']);

export function recordVisit(path, label) {
  if (!path || SKIP.has(path)) return;
  try {
    const cur = (JSON.parse(localStorage.getItem(KEY) || '[]') || []).filter(r => r.path !== path);
    cur.unshift({ path, label: label || path, at: Date.now() });
    localStorage.setItem(KEY, JSON.stringify(cur.slice(0, 5)));
  } catch { /* ignore */ }
}

export function getRecentPages() {
  try { return JSON.parse(localStorage.getItem(KEY) || '[]') || []; } catch { return []; }
}
